// External Dependencies:
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

// Internal Dependencies:
import { doRequest } from 'church-theme-library/utilities/request'
import { getHostname, getLocalPathFromUrl } from 'church-theme-library/utilities/url'
import { safelyParseJSON } from 'church-theme-library/utilities/json'
import MediaPlayer from 'church-theme-library/components/MediaPlayer/MediaPlayer'
import Form from 'church-theme-library/components/Form/Form'
import LoadScript from 'church-theme-library/containers/LoadScript'

// Redux
import { getScreenSize, getMenuData, setMenuOverflowItems } from 'church-theme-library/redux/actions/site'
import { getFeaturedImage } from 'church-theme-library/redux/actions/page'

const siteHostname = window.location.hostname

class PageEvents extends React.Component {
	constructor() {
		super()

		this.state = {
			hasForms: false
		}

		this.currentFormSubmitEvent = null
	}

	componentWillUnmount() {
		window.removeEventListener( 'resize', this.onResize )
		window.removeEventListener( 'click', this.handleLinkClick )
		window.removeEventListener( 'click', this.handleShareLinkClick )
		window.removeEventListener( 'click', this.handleNotificationsClick )
		window.removeEventListener( 'click', this.handleAccordionTitleClick )
		window.removeEventListener( 'click', this.handleImageGalleryItemClick )
		window.removeEventListener( 'submit', this.handleFormSubmit )
	}

	componentDidMount() {
		this.update()
		this.onResize()

		window.addEventListener( 'resize', this.onResize )

		// Listen for editor events:
		window.addEventListener( 'dkeEditorContentLoaded', () => {
			this.update()
		}, false )

		window.addEventListener( 'dkeEditorFormUpdated', () => {
			this.updateFormHolders()
		}, false )

		window.addEventListener( 'dkeEditorVideoUpdated', () => {
			this.updateVideos()
		}, false )

		window.addEventListener( 'dkeEditorIframeUpdated', () => {
			this.updateIframes()
		}, false )

		window.addEventListener( 'dkeEditorPageChanged', () => {
			this.updatePage()
		}, false )

		window.addEventListener( 'dkeEditorPageDeleted', ( e ) => {
			this.updatePageDeleted( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorPageAdded', ( e ) => {
			this.updatePageAdded( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorFeaturedImageChanged', ( e ) => {
			this.updateFeaturedImage( e.detail )
		}, false )

		window.addEventListener( 'dkeEditorMenuChanged', () => {
			this.updateMenu()
		}, false )
	}

	componentDidUpdate( prevProps, prevState ) {
		this.update()
	}

	onResize = () => {
		this.idleCallback = window.requestIdleCallback( this.onResizeCheckMenu )
		this.props.dispatch( getScreenSize() )
	}

	onResizeCheckMenu = () => {
		const { dispatch } = this.props
		const elements = document.querySelectorAll( '.js-priority-plus-menu-item' )
		const elementsArray = Array.from( elements )
		let firstTop = 0
		const overflowItems = []

		if ( elementsArray.length > 1 ) {
			firstTop = elementsArray[0].getBoundingClientRect().top
		}

		elementsArray.forEach( ( element ) => {
			let top = element.getBoundingClientRect().top

			if ( top != firstTop ) {
				overflowItems.push( element.getAttribute( 'data-id' ) )
			}
		} )

		dispatch( setMenuOverflowItems( overflowItems ) )
	}

	update = () => {
		// Links:
		const elements = document.querySelectorAll( '.content-body-wrap a, .content-custom-wrap a, .page-sections a' )

		Array.from( elements ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleLinkClick )
		} )

		// Forms:
		this.updateFormHolders()

		// Notifications:
		const notifications = document.querySelectorAll( '.notification' )

		Array.from( notifications ).forEach( ( element ) => {
			element.addEventListener( 'click', this.handleNotificationsClick )
		} )

		// Accordions:
		const accordionTitles = document.querySelectorAll( '.accordion-title' )

		Array.from( accordionTitles ).forEach( ( accordionTitle ) => {
			accordionTitle.addEventListener( 'click', this.handleAccordionTitleClick )
		} )

		// Gallery items:
		const galleryItems = document.querySelectorAll( '.image-gallery-item' )

		Array.from( galleryItems ).forEach( ( item ) => {
			item.addEventListener( 'click', this.handleImageGalleryItemClick )
		} )

		// Videos:
		this.updateVideos()

		// Iframes:
		this.updateIframes()
	}

	updateFormHolders = () => {
		const { hasForms } = this.state

		const forms = document.querySelectorAll( '.form-data' )

		Array.from( forms ).forEach( ( element ) => {
			let id = element.getAttribute( 'data-id' )
			let dataString = element.getAttribute( 'data-data' )
			let data = safelyParseJSON( dataString )

			ReactDOM.render(
				<Form
					data={ data }
					values={ {} }
					wihtoutStore={ true }
				/>,
				element
			)
		} )

		if ( ! hasForms && forms && forms.length ) {
			this.setState( {
				hasForms: true
			} )
		}

		setTimeout( () => {
			this.updateForms()
		}, 400 )
	}

	updateForms = () => {
		const forms = document.querySelectorAll( '.content-body-wrap form, .content-custom-wrap form, form.vl-form' )

		Array.from( forms ).forEach( ( form ) => {
			form.addEventListener( 'submit', this.handleFormSubmit )
		} )
	}

	updateVideos = () => {
		const videos = document.querySelectorAll( '.video-data' )

		Array.from( videos ).forEach( ( element ) => {
			let id = element.getAttribute( 'data-video-id' )
			let service = element.getAttribute( 'data-type' )
			let url = element.getAttribute( 'data-url' )
			let thumbnail = element.getAttribute( 'data-thumbnail' )

			ReactDOM.render(
				<MediaPlayer id={ id } service={ service } url={ url } thumb_url={ thumbnail } />,
				element
			)
		} )
	}

	updateIframes = () => {
		const iframes = document.querySelectorAll( '.iframe-data' )

		Array.from( iframes ).forEach( ( element ) => {
			let url = element.getAttribute( 'data-url' )
			let width = element.getAttribute( 'data-width' )
			let height = element.getAttribute( 'data-height' )

			if ( width && height ) {
				let aspectRatio = parseInt( width, 10 ) / parseInt( height, 10 )
				element.style.paddingBottom = 100 / aspectRatio + '%'
			} else {
				element.style.removeProperty( 'padding-bottom' )
			}

			ReactDOM.render(
				<iframe src={ url } frameBorder="0" allow="autoplay; fullscreen" allowFullScreen />,
				element
			)
		} )
	}

	updatePage = () => {
		const { history } = this.props

		history.push( history.location.pathname )
	}

	updatePageAdded = ( data ) => {
		const { history } = this.props
		const path = getLocalPathFromUrl( data.url )

		history.push( path )
	}

	updatePageDeleted = ( data ) => {
		const { history, page } = this.props

		if ( page && data.post_id == page.id ) {
			history.push( '/' )
		}
	}

	updateFeaturedImage = ( data ) => {
		const { dispatch } = this.props

		dispatch( getFeaturedImage( data.post_id, data.slug, data.taxonomy ) )
	}

	updateMenu = () => {
		const { dispatch } = this.props

		dispatch( getMenuData() )
	}

	handleNotificationsClick = ( e ) => {
		e.currentTarget.classList.toggle( 'is-closed' )
	}

	handleLinkClick = ( e ) => {
		const editorIsOpen = document.documentElement.classList.contains( 'with-editor-open' )

		if ( editorIsOpen ) {
			e.preventDefault()
			return
		}

		const { history } = this.props
		let href = e.currentTarget.getAttribute( 'href' ).replace( /^(\.+)/g, '' ),
			linkHostname = getHostname( href ),
			isFullUrl = href.indexOf( '//' ) > -1,
			isPartOfSite = linkHostname.indexOf( siteHostname ) > -1,
			isSubDomainOfSite = isPartOfSite && siteHostname.indexOf( linkHostname ) === -1,
			isThisSite = isPartOfSite && ! isSubDomainOfSite

		if ( href.indexOf( 'mailto:' ) > -1 ) {
			return // Email link, allow normal behaviour.
		} else if ( /^(?=.*\.[^\/.]+$).*/.test( href ) ) {
			window.open( href, '_blank' ) // File with extension, in new tab.
		} else if ( isSubDomainOfSite && isFullUrl ) {
			window.location = href // Subdomain, open normally.
		} else if ( ! isPartOfSite && isFullUrl ) {
			window.open( href, '_blank' ) // External site, in new tab.
		} else if ( '#' == href.charAt( 0 ) ) {
			let hash = href.substring( 1 )
			window.location.hash = hash // Hash, jump.
		} else {
			history.push( getLocalPathFromUrl( href ) ) // Same site, use router.
		}

		e.preventDefault()
	}

	handleFormSubmitRecaptchaCheck = ( form ) => {
		if ( window.grecaptcha ) {
			const recaptchaElement = form.querySelector( '.recaptcha' )

			// Render the recaptcha if not already rendered:
			if ( recaptchaElement && ! recaptchaElement.children.length ) {
				window.grecaptcha.render( recaptchaElement, {
					sitekey: siteData.google_recaptcha_key,
					size: 'invisible',
					callback: this.handleFormSubmitRecaptchaResponse
				} )
			}

			setTimeout( () => {
				window.grecaptcha.execute()
			}, 200 )
		} else {
			this.handleFormSubmit( e, true )
		}
	}

	handleFormSubmitRecaptchaResponse = ( token ) => {
		window.grecaptcha.reset()

		this.handleFormSubmit( this.currentFormSubmitEvent, token )
	}

	handleFormSubmit = ( e, recaptchaToken = false ) => {
		e.preventDefault()

		const form = e.target
		const buttons = form.querySelectorAll( 'button' )
		const hasRecaptcha = form.classList.contains( 'has-recaptcha' )

		// Disable the button:
		if ( buttons.length ) {
			buttons[0].setAttribute( 'disabled', 'disabled' )
		}

		// Show processing UI:
		form.classList.remove( 'is-successful' )
		form.classList.add( 'is-processing' )

		// If using recaptcha, first do check:
		if ( hasRecaptcha && ! recaptchaToken ) {
			this.currentFormSubmitEvent = e
			this.handleFormSubmitRecaptchaCheck( form )

			return
		}

		// Set form data:
		const formData = new FormData( form )
		formData.append( 'action', 'dkh_theme_submit_form' )

		// If received recaptcha response:
		if ( recaptchaToken ) {
			this.currentFormSubmitEvent = null
			formData.append( 'g-recaptcha-response', recaptchaToken )
		}

		// Submit:
		doRequest( siteData.ajax_url, {
			method: 'POST',
			data: formData,
			responseType: 'text'
		} )
			.then( message => {
				// Success:

				form.classList.remove( 'has-error' )
				form.setAttribute( 'data-message', '' )

				form.classList.remove( 'is-processing' )
				form.classList.add( 'is-processed' )

				// Add a delay for UX:
				setTimeout( () => {
					form.classList.remove( 'is-processed' )
					form.classList.add( 'is-successful' )

					// Set the success message:
					message && form.setAttribute( 'data-message', message )

					setTimeout( () => {
						form.classList.remove( 'is-successful' )

						// Enable the button:
						if ( buttons.length ) {
							buttons[0].removeAttribute( 'disabled', 'disabled' )
						}

						// Clear the form:
						form.reset()
					}, 3000 )
				}, 1000 )
			} )
			.catch( error => {
				// Error:
				form.classList.remove( 'is-processing' )
				form.classList.add( 'is-processed' )

				// Add a delay for UX:
				setTimeout( () => {
					form.classList.remove( 'is-processed' )
					form.classList.add( 'is-unsuccessful' )

					// Set the error text:
					form.classList.add( 'has-error' )
					error && form.setAttribute( 'data-message', error )

					setTimeout( () => {
						form.classList.remove( 'is-unsuccessful' )

						// Enable the button:
						if ( buttons.length ) {
							buttons[0].removeAttribute( 'disabled', 'disabled' )
						}
					}, 3000 )
				}, 1000 )
			})
	}

	handleAccordionTitleClick = ( e ) => {
		e.preventDefault()

		let section = e.currentTarget.parentNode

		if ( ! section.classList.contains( 'is-active' ) && ! section.classList.contains( 'is-target' ) ) {
			section.classList.remove( 'is-not-active' )
			section.classList.add( 'is-active' )
		} else {
			section.classList.add( 'is-closing' )
			section.classList.remove( 'is-active' )
			section.classList.remove( 'is-target' )

			setTimeout( () => {
				section.classList.remove( 'is-closing' )
				section.classList.add( 'is-not-active' )
			}, 750 )
		}
	}

	handleImageGalleryItemClick = ( e ) => {
		e.preventDefault()

		const item = e.currentTarget

		item.classList.toggle( 'is-active' )
	}

	render() {
		const { hasForms } = this.state
		let returnValue = null

		if ( hasForms ) {
			returnValue = (
				<LoadScript
					src="https://www.google.com/recaptcha/api.js"
				/>
			)
		}

		return returnValue
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default withRouter(
	connect( mapStateToProps )( PageEvents )
)
